/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-05-12 16:54:01
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-26 16:15:38
 */
import React from 'react'
import './index.css'
import { standardSize } from '../../../utils/tools.js'
import { Modal } from 'antd';
import wordimg from './img/icon-word.png'
import xlsximg from './img/icon-xlsx.png'
import playimg from './img/icon-play.png'
import stopimg from './img/icon-stop.png'
import pauseimg from './img/icon-pause.png'
import pausestateimg from './img/icon-time-out.png'
import progressingstateimg from './img/icon-handle.png'
import readyimg from './img/icon-updated.png'
import $ from 'jquery'

const DISALLOWED_FILE_EXTENSIONS = [
    // 脚本和动态内容文件
    "php", "asp", "aspx", "jsp", "cgi", "pl", "py", "rb", "sh", "bat", "cmd",

    // 配置文件
    "htaccess", "web.config",

    // 可执行文件
    "exe", "msi", "dll", "com", "cmd",
    "jar",

    // 压缩包
    // "zip", rar", "tar", "gz", "7z",

    // 其他潜在风险文件
    // "xml", "json",
    "html", "htm", "svg"
];

var WebUploader = window.WebUploader;
const uploadingList = [{
    fileName: '上传文34324234234324件名称 .doc', size: 100000000,
    offset: 1324000, status: 'paused'
},
{
    fileName: '上传文件名称 .xlsx', size: 20000,
    offset: 13200, status: 'progressing'
},
{
    fileName: '上传文件名称 .xlsx', size: 13200,
    offset: 13200, status: 'completed'
}, {
    fileName: '上传文34324234234324件名称 .doc', size: 100000000,
    offset: 1324000, status: 'paused'
},
{
    fileName: '上传文件名称 .xlsx', size: 20000,
    offset: 13200, status: 'progressing'
},
{
    fileName: '上传文件名称 .xlsx', size: 13200,
    offset: 13200, status: 'completed'
}, {
    fileName: '上传文34324234234324件名称 .doc', size: 100000000,
    offset: 1324000, status: 'paused'
},
{
    fileName: '上传文件名称 .xlsx', size: 20000,
    offset: 13200, status: 'progressing'
},
{
    fileName: '上传文件名称 .xlsx', size: 13200,
    offset: 13200, status: 'completed'
}]

const error = () => {
    Modal.error({
        title: 'This is an error message',
        content: 'some messages...some messages...',
    });
};


var uploader
const retryTimes = 0
class UploadPanel extends React.Component {
    state = {
        visible: false,
        uploadingList: [],
        // uploader: {}
    }
    componentDidMount() {
        var _this = this
        WebUploader.Uploader.unRegister('custom');
        WebUploader.Uploader.register({
            name: 'custom',
            'before-send-file': 'beforeSendFile',//整个文件上传前  可以进行压缩、裁剪、分片操作
            'before-send': 'beforeSend',//每个分片上传前
            "after-send-file": "afterSendFile"  //所有分片上传完毕
        }, {
            'beforeSend': function (block) {
                // debugger
                let task = new $.Deferred();
                let chunk = block.chunk;
                // 服务器端要接收的切块序号
                let chunkIndex = block.file.chunkIndex;
                if (chunkIndex && chunk < chunkIndex) {
                    task.reject();
                } else {
                    console.log(`正在上传第${chunk}块， 块数据：`, block);
                    task.resolve();
                }
                return $.when(task);
            },
            'beforeSendFile': function (file) {
                const fileExtension = file.name.split('.').pop();
                if(DISALLOWED_FILE_EXTENSIONS.includes(fileExtension)){
                    // debugger
                    console.log(`${file.name} 的扩展名类型被禁止上传`);
                }
                let task = new $.Deferred();
                // 对整个文件计算md5，并查询服务端是否存在s
                // if (_this.props.totalVolume - _this.props.usageVolume <= file.size) {
                //     console.log('111111111111111111111111111111111111111111111111111111111')
                //     this.owner.removeFile(file);
                //     Modal.error({
                //         title: '上传文件错误',
                //         content: '文件大小超过个人云盘大小',
                //     });
                //     task.reject();
                //     return $.when(task);
                // }
                if (file.status !== 'error') {
                    this.owner.md5File(file).progress(per => {
                        console.log("正在计算 " + file.name + " 的md5值 " + per)
                    }).then(val => {
                        console.log("计算 " + file.name + " md5值完成: " + val);
                        // md5Map[file.id] = val;
                        // let md5 = md5Map[fileId];
                        file.md5 = val;
                        $.ajax({
                            type: 'GET',
                            url: global.support.cdSupport + '/oss/checkExist?md5=' + val,
                            async: false,
                            error: e => {
                                file.statusText = '服务器错误';
                                task.reject();
                            }
                        }).then(res => {
                            console.log("检验文件存在性结果：", res);
                            if (res.payload && res.payload.isUploaded) {
                                console.log("文件已上传过，跳过");
                                file.path = res.payload.path;
                                this.owner.skipFile(file);
                                // file.status = 'canceled';
                                file.status = 'completed';
                                console.log(file)
                                // Modal.error({
                                //     title: '上传文件错误',
                                //     content: '该文件已存在于个人云盘中，请修改文件名后上传',
                                // });
                            }
                            if (res.payload && res.payload.chunkIndex) {
                                console.log("文件已上传过但没完成，到第" + res.payload.chunkIndex + "片");
                                file.chunkIndex = res.payload.chunkIndex;
                                file.offsetIndex = res.payload.offsetIndex;
                                file.path = res.payload.path;
                            }
                            task.resolve();
                        });
                    });
                }
                return $.when(task);
            },
            afterSendFile: function (file) {
            }
        });
        uploader = WebUploader.create({
            auto: true,// 选完文件后，是否自动上传。
            swf: 'webuploader-0.1.5/Uploader.swf',// swf文件路径
            server: global.support.cdSupport + '/oss/uploadChunk',// 文件接收服务端。
            dnd: '#upload-container',
            pick: {  //文件选择器按钮设置
                id: '#filePicker',
                multiple: true  //是否支持多选
            },
            multiple: true, // 选择多个
            chunked: true,// 开起分片上传。
            chunkSize: 5 * 1024 * 1024, //每片10M 如果要分片，分多大一片？ 默认大小为5M
            threads: 1, // 上传并发数。允许同时最大上传进程数。
            method: 'POST', // 文件上传方式，POST或者GET。
            fileSizeLimit: 1024 * 1024 * 1024 * 10, //验证文件总大小是否超出限制, 超出则不允许加入队列。
            fileSingleSizeLimit: 1024 * 1024 * 1024 * 10, //验证单个文件大小是否超出限制, 超出则不允许加入队列。
            // fileVal: 'file', // [默认值：'file'] 设置文件上传域的name。        
        });
        uploader.on('fileQueued', function (file) {
            // debugger
            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (DISALLOWED_FILE_EXTENSIONS.includes(fileExtension)) {
                Modal.error({
                    title: '文件类型错误',
                    content: `禁止上传 .${fileExtension} 类型文件！`,
                });
                uploader.cancelFile(file.id);
                return;
            }
            console.log('上传列表：',file);
            if (_this.props.totalVolume - _this.props.usageVolume <= file.size) {
                Modal.error({
                    title: '上传文件错误',
                    content: '文件大小超过个人云盘大小',
                });
                file.status = 'error'
            } else {
                // 选中文件时要做的事情，比如在页面中显示选中的文件并添加到文件列表，获取文件的大小，文件类型等
                //    debugger
                console.log(file.ext) // 获取文件的后缀
                console.log(file.size) // 获取文件的大小
                console.log(file.name);
                // console.log(file)
                // var html = '<div class="upload-item"><span>文件名：' + file.name + '</span><span data-file_id="' + file.id + '" class="btn-delete">删除</span><span data-file_id="' + file.id + '" class="btn-retry">重试</span><div class="percentage ' + file.id + '" style="width: 0%;"></div></div>';
                // $('#upload-list').append(html);
                let { uploadingList } = _this.state
                file.percentage = 0;
                file.status = 'progressing'
                file.failedTimes = 0
                file.folder = _this.props.folder
                // debugger
                uploadingList.push(file)
                // console.log(file)
                _this.setState({ uploadingList: uploadingList, visible: true })
            }
        });
        uploader.on('uploadProgress', function (file, percentage) {
            // debugger
            console.log('文件传输中：' + file.name + percentage * 100 + '%');
            // var width = $('.upload-item').width();
            // $('.' + file.id).width(width * percentage);
            let { uploadingList } = _this.state
            let curfile = uploadingList[_this.findfileindexbyid(file.id)]
            if (curfile == null) {
                return
            }
            curfile.percentage = percentage
            _this.setState({ uploadingList: uploadingList })
        });
        uploader.on('uploadSuccess', function (file, response) {
            console.log(file.name + file.id + "传输成功");
            // for (let x in response) {
            console.log(response);
            // }
            _this.props.onFileUpload(file, response)
            let { uploadingList } = _this.state
            let curfile = uploadingList[_this.findfileindexbyid(file.id)]
            if (curfile == null) {
                return
            }
            if (curfile.status !== 'canceled') {
                curfile.status = 'completed'
            }
            curfile.percentage = 1
            _this.setState({ uploadingList: uploadingList })
        });
        uploader.on('uploadError', function (file, eee) {
            console.log(eee);
            console.log(file);
            console.log(file.id + '上传失败')
            let { uploadingList } = _this.state
            let curfile = uploadingList[_this.findfileindexbyid(file.id)]
            console.log(curfile)
            if (curfile == null) {
                return
            }
            if (curfile.failedTimes >= retryTimes) {
                curfile.failedTimes++
                uploader.upload(file.id)
            }
            else { curfile.status = 'error' }
            _this.setState({ uploadingList: uploadingList })
        });
        uploader.on('uploadBeforeSend', function (chunk, data, headers) {
            // debugger
            // data.md5 = md5Map[chunk.file.id];
            data.md5 = chunk.file.md5;
            data.filename = data.name;
            data.fileSize = data.size;
            data.mimeType = data.type;
            data.totalChunk = data.chunks;
        });
        // uploader.on('uploadComplete', function (file) {
        //     console.log(file.name + "   上传任务完成，失败也会调用");
        // });
        // uploader.on('uploadFinished', function (file) {
        //     console.log("所有上传结束，失败也会调用");
        // });
    }

    findfileindexbyid = (id) => {
        var { uploadingList } = this.state
        var index;
        uploadingList.forEach((v, i) => {
            if (v.id === id) index = i
        })
        return index
    }

    pause = (file) => {
        var { uploadingList } = this.state
        // debugger
        var fileinfo = uploadingList[this.findfileindexbyid(file.id)]
        if (file.status === 'progressing') {
            console.log(file.name + "   暂停");
            fileinfo.status = 'paused'
            uploader.stop(file.id, true)
        } else {
            fileinfo.status = 'progressing'
            console.log(file.name + "   继续");
            uploader.upload(file.id)
        }
        this.setState({ uploadingList: uploadingList })
    }

    cancel = (file) => {
        var { uploadingList } = this.state
        var fileinfo = uploadingList[this.findfileindexbyid(file.id)]

        uploader.cancelFile(file.id)
        fileinfo.status = 'canceled'
        this.setState({ uploadingList: uploadingList })
    }

    restart = (file) => {
        var { uploadingList } = this.state
        var fileinfo = uploadingList[this.findfileindexbyid(file.id)]
        fileinfo.status = 'progressing'
        uploader.upload(file.id)
        this.setState({ uploadingList: uploadingList })
    }

    visibleChange = (visible) => {
        this.setState({ visible: visible })
    }

    render() {
        let { uploadingList } = this.state
        // console.log(uploadingList)
        return (<div className='clouddisk-upload-panel'>
            <div className='clouddisk-upload-title-panel' onClick={() => this.visibleChange(!this.state.visible)}>
                <span className='clouddisk-upload-title-panel-title'>上传列表&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span className='clouddisk-upload-title-panel-info'>{uploadingList.length > 0 && `(${uploadingList.length} 个文件)`}</span>
            </div>
            <div className={`clouddisk-upload-content-panel${this.state.visible ? '' : ' clouddisk-upload-content-panel-hidden'}`}>
                {
                    uploadingList.map((uploadfile, index) => <UploadFile data={uploadfile} restart={this.restart} pause={this.pause} cancel={this.cancel} key={index}></UploadFile>)
                }
            </div>
        </div>)
    }
}

const UploadFile = (props) => {
    let { name, size, status, offset, percentage } = props.data
    let { pause, cancel, restart } = props
    let showsize = standardSize(size, 1)
    let state, stateicon, opreationicon, cancelicon, stateColor
    // let percent = offset / size
    // console.log(status)
    switch (status) {
        case 'completed':
            state = '已上传'
            stateicon = <img className='clouddisk-upload-file-state-img' src={readyimg}></img>
            stateColor = 'rgba(15,233,0,1)'
            break;
        case 'paused':
            state = '已暂停'
            stateicon = <img className='clouddisk-upload-file-state-img' src={pausestateimg}></img>
            stateColor = 'rgba(6,17,120,1)'
            opreationicon = <img className='clouddisk-upload-file-run' src={playimg} onClick={pause.bind(this, props.data)}></img>
            cancelicon = <img className='clouddisk-upload-file-cancel' src={stopimg} onClick={cancel.bind(this, props.data)}></img>
            break;
        case 'progressing':
            state = '正在处理(' + (percentage * 100).toFixed(2) + '%)'
            stateicon = <img className='clouddisk-upload-file-state-img' src={progressingstateimg}></img>
            stateColor = 'rgba(0,114,229,1)'
            opreationicon = <img className='clouddisk-upload-file-run' src={pauseimg} onClick={pause.bind(this, props.data)}></img>
            cancelicon = <img className='clouddisk-upload-file-cancel' src={stopimg} onClick={cancel.bind(this, props.data)}></img>
            break;
        case 'error':
            state = '传输失败'
            stateicon = <img className='clouddisk-upload-file-state-img' src={pausestateimg}></img>
            stateColor = 'red'
            // opreationicon = <img className='clouddisk-upload-file-run' src={playimg} onClick={pause.bind(this, props.data)}></img>
            cancelicon = <img className='clouddisk-upload-file-cancel' src={playimg} onClick={restart.bind(this, props.data)}></img>
            break;
        case 'canceled':
            state = '已取消'
            stateicon = <img className='clouddisk-upload-file-state-img' src={pausestateimg}></img>
            cancelicon = <img className='clouddisk-upload-file-cancel' src={playimg} onClick={restart.bind(this, props.data)}></img>
            stateColor = 'red'
            break;
        default:
            state = '未知'
            break;
    }

    return (<div className='clouddisk-upload-file'>
        <div>
            <img className='clouddisk-upload-file-icon' src={wordimg}></img>
        </div>
        <div className='clouddisk-upload-file-name' >{name}</div>
        <div className='clouddisk-upload-file-size' >{showsize}</div>
        <div>
            {stateicon}
        </div>
        <div className='clouddisk-upload-file-state' style={{ color: stateColor }}>{state}</div>
        <div className='clouddisk-upload-file-opera'>
            {/* {opreationicon} */}
            {cancelicon}
        </div>
        <div className='clouddisk-upload-progressingbar' style={{ width: percentage * 600 }}></div>
    </div>)

}
export default UploadPanel